import React from "react";

export default function Title() {

    const today = new Date();
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' };
    const formattedDate = today.toLocaleDateString(undefined, options);

    return (
        <>
            <p className="title1">Pin The Bay, {formattedDate}</p>
        </>
    );
};